import Link from "next/link";
import { UseFormReturn } from "react-hook-form";
import { ErrorMessageComponent } from "../../Common/Input/ErrorMessage/ErrorMessage";
import PasswordFieldComponent from "../../Common/Input/Password/Password";
import { LoginFormSchemaType } from "./LoginFormSchema";
import { PrimeButton } from "../../prime/button";
import { PrimeLink } from "../../prime/link";

interface AuthLoginComponentProps {
  info?: string;
  isFetching: boolean;
  onSubmit: (data: any) => Promise<void>;
  useFormProps: UseFormReturn<LoginFormSchemaType>;
  componentId?: string;
}

export const AuthLoginComponent = (props: AuthLoginComponentProps) => {
  const { info, onSubmit, isFetching, useFormProps } = props;

  return (
    <form id={props.componentId} onSubmit={useFormProps.handleSubmit(onSubmit)}>
      <div>
        <input
          id={props.componentId + "-input-email"}
          type="text"
          className={`fp-text-input static ${
            useFormProps.formState.errors.email?.message && `border-red-700`
          }`}
          placeholder="Email"
          autoComplete="email"
          {...useFormProps.register("email")}
          disabled={isFetching}
        />
        <ErrorMessageComponent
          componentId={props.componentId + "-input-email"}
          fieldError={useFormProps.formState.errors.email}
        />
      </div>
      <div className="mt-4">
        <PasswordFieldComponent
          fieldError={useFormProps.formState.errors.password}
          register={useFormProps.register}
          name="password"
          showCheckboxes={false}
          disabled={isFetching}
          componentId={props.componentId}
        />
      </div>

      <div
        id={props.componentId + "-link-forgot-password"}
        className="flex justify-end mt-4 mb-8"
      >
        <PrimeLink className="text-sm" href="/reset-password" nextLink>
          Forgot password
        </PrimeLink>
      </div>

      <PrimeButton
        size="large"
        id={props.componentId + "-submit-button"}
        type="submit"
        status={isFetching ? "loading" : "default"}
      >
        Sign in
      </PrimeButton>
    </form>
  );
};
